var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-body"},[_vm._m(0),_c('CompanySettingsNavbar',{on:{"open-invite-modal":function($event){return _vm.$emit('open-invite-modal')}}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row align-items-center justify-content-center"},[_c('div',{staticClass:"col"},[_c('h1',{staticClass:"header-title mt-4 mb-2"},[_vm._v("Settings")])])])
}]

export { render, staticRenderFns }